import {
  Card, CardContent, CardActions, Typography,
  Box, styled, Link
} from '@mui/material';
import { useRouter } from 'next/router';
import Image from 'next/image';

const StyledCard = styled(Card)`
  cursor: pointer;
  overflow: hidden;
  margin: 0;
  &:last-child {  margin: 0; }
  img { transition: transform 300ms ease-in-out; background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.9)); }
  &:hover img { transform: scale(1.02); }`;

export default function Idea({ post, index, spaceEvenly }) {

  const router = useRouter()
  const convertTime12to24 = time12h => {
    const [time, modifier] = time12h?.split(' ');
    let [hours, minutes, seconds] = time ? time.split(':') : null;
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replase = n?.replace(new RegExp(',', 'g'), ' ')
    return `${replase} • ${convertTime12to24(t)}`
  }

  return (
    <Link underline="none" href={`/stock-ideas/${post.slug}`}
      sx={{
        '&:hover .idea-title': { color: '#fff', textDecoration: 'underline', },
        '&:hover .idea-card': { borderColor: '#fff', },
      }}
    >
      <StyledCard key={index} className={post?.frontmatter?.tags?.find(d => d === 'premium') ? 'premium-blog' : 'blog'}
        sx={{
          cursor: 'pointer', borderRadius: 0, boxShadow: 0, mb: 0,
          overflow: 'hidden', height: '100%', background: 'transparent'
        }}>
        <CardContent
          className="idea-card"
          sx={{
            p: '12px 2px !important', mx: 1.7, mt: 0, display: 'flex', flexDirection: 'column',
            justifyContent: 'space-between', borderBottom: 1, borderColor: '#c0c0c0', height: '100%',
          }}>
          <div>
            <Typography variant="h6" component="div"
              className="idea-title"
              sx={{
                fontWeight: 600, fontSize: { md: '1.1rem', sm: '1.1rem', xs: '.875rem' }, color: '#fff',
                '& a': { color: '#fff', textDecoration: 'none' },
                '& a:hover': { color: '#fff', textDecoration: 'underline' }, lineHeight: 1.2, mt: 1, mb: 0.7,
                display: '-webkit-box', WebkitLineClamp: { md: 1, sm: 1, xs: 1 }, WebkitBoxOrient: 'vertical',
                overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
              {post?.frontmatter?.title}
            </Typography>
            <Typography variant="caption" component="div" sx={{ fontWeight: 500, fontSize: '.8rem', mb: 1 }} color="#D4D4D4">
              {getDate(post?.frontmatter?.date)}
            </Typography>
          </div>
          <div style={{ position: 'relative' }}>
            <Typography variant="body1"
              sx={{
                fontSize: '.87rem', display: '-webkit-box',
                WebkitLineClamp: { md: 1, sm: 1, xs: 1 }, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis',
              }}
              color="#D4D4D4"  // color="text.secondary"
              dangerouslySetInnerHTML={{
                __html: post?.frontmatter?.new ? `What's New: ${post?.frontmatter?.new}` : `${post?.frontmatter?.description}`
              }}
            />
            {/* <Typography variant="body1" sx={{
              fontSize: '.84rem', position: 'absolute',
              bottom: 0, right: 0, background: '#fff', '& ._': { color: '#333', textDecoration: 'underline' }, '&:hover ._': { color: '#174ea6', },
              '..': { color: '#333', textDecoration: 'underline' }
            }}
            >
              <span className=".">{`... `}</span><span className="_">{`Read more`}</span>
            </Typography> */}
          </div>
        </CardContent>
      </StyledCard>
    </Link >
  )
}
